import { useEffect, useState } from "react";

import { Box } from "@material-ui/core";

import { Table } from "../../../../components/table";
import TrashIcon from "../../../../assets/images/icons/trash.svg";
import { NoTableData } from "../../../../components/parts";
import { api, formatDatetime, getData } from "../../../../services";

const cellStyle = { padding: "18px 0 18px 32px" };

export const PortfolioAlert = ({ building, complex }) => {
  const [alerts, setAlerts] = useState([]);

  let url = `/praas/v1/buildings/tenants-alerts/`;

  if (building?.id) {
    url = `/praas/v2/buildings/${building.id}/tenants/alerts/`;
  } else if (complex?.id) {
    url = `/praas/v2/complexes/${complex.id}/tenants/alerts/`;
  }

  useEffect(() => {
    getData(url, setAlerts);

    return () => setAlerts([]);
  }, [building?.id, complex?.id]);

  const handleClick = (i) => {
    api.delete(`${url}${alerts[i].id}`).then(() => {
      const tempAlerts = [...alerts];
      tempAlerts.splice(i, 1);
      setAlerts(tempAlerts);
    });
  };

  if (!alerts.length) return <NoTableData title="No alerts yet" />;

  return (
    <Box>
      <Table
        headers={["Type", "Date", "Description"]}
        data={alerts.map((alert) => [
          alert.type,
          formatDatetime(alert.date, "MMM D, YYYY"),
          alert.description,
        ])}
        colWidths={[25, 18, 52, 5]}
        endIcon={TrashIcon}
        cellStyles={[cellStyle, cellStyle, cellStyle, cellStyle]}
        onEndIconClick={handleClick}
      />
    </Box>
  );
};
